//POS_LIST
export const REQUEST_POS_LIST = 'REQUEST_POS_LIST';
export const RECIEVE_POS_LIST = 'RECIEVE_POS_LIST';
export const REQUEST_POS_LIST_ERROR = 'REQUEST_POS_LIST_ERROR';
export const CLEAR_POS_LIST = 'CLEAR_POS_LIST';
